// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography, CircularProgress } from '@metarouter-private/mr-mui';

export default function BulkOperationProgressView({ progress, message = 'Processing files...' }) {
  return (
    <Stack spacing={2} sx={{ py: 2 }} alignItems="center">
      <CircularProgress />
      <Typography variant="h6">{message}</Typography>
      <Typography variant="body2" color="text.secondary">
        {progress.current} / {progress.total} files
      </Typography>
    </Stack>
  );
}

BulkOperationProgressView.propTypes = {
  progress: PropTypes.shape({
    current: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
  }).isRequired,
  message: PropTypes.string,
};
